<template>
  <div :class="shareIconsClasses">
    <component
      v-for="(icon, index) in icons"
      :key="icon.icon"
      :is="getIconComponent(icon)"
      :icon="icon.icon"
      :to="icon.url"
      :title="icon.info"
      :title-width="90"
      :is-button="icon.isButton"
      :aria-label="icon.ariaLabel"
      :width="iconWidth"
      :height="iconHeight"
      :color="iconColor"
      :disabled="icon.disabled"
      :open-in-new-tab="openInNewTab || icon.openInNewTab"
      :directive="icon.directive"
      :comment-count="icon.commentCount"
      :original="icon.original"
      :action-icon="ACTION_ICON.IL_COMMENT_COUNT"
      :style="calculateIconStyle(index)"
      class="share-icon social-icon-border"
      @click="onIconClick(icon)"
    />
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AIcon, { ICON, ICON_COLOR, ICON_COLOR_VALUES } from 'shared/AIcon'
import AActionIcon, { ACTION_ICON } from 'shared/AActionIcon'
import { ICON_LIST_LAYOUT } from 'shared/AIconList/enums'

export default {
  name: 'AIconList',
  components: { AIcon, AActionIcon },
  props: {
    icons: propValidator([PROP_TYPES.ARRAY]),
    iconWidth: propValidator([PROP_TYPES.NUMBER], false, 35),
    iconHeight: propValidator([PROP_TYPES.NUMBER], false, 35),
    verticalSpacing: propValidator([PROP_TYPES.NUMBER], false, 25),
    maxIconCount: propValidator([PROP_TYPES.NUMBER], false, 5),
    iconColor: propValidator(
      [PROP_TYPES.STRING],
      false,
      ICON_COLOR.BLACK,
      prop => ICON_COLOR_VALUES.includes(prop)
    ),
    layout: propValidator(
      [PROP_TYPES.STRING],
      false,
      ICON_LIST_LAYOUT.HORIZONTAL,
      prop => Object.values(ICON_LIST_LAYOUT).includes(prop)
    ),
    autocalculatedMargins: propValidator([PROP_TYPES.BOOLEAN], false, true),
    openInNewTab: propValidator([PROP_TYPES.BOOLEAN], false, false),
    descriptionAbsolutePosition: propValidator(
      [PROP_TYPES.BOOLEAN],
      false,
      false
    )
  },
  data() {
    return { ACTION_ICON }
  },
  computed: {
    isVerticalLayout() {
      return this.layout === ICON_LIST_LAYOUT.VERTICAL
    },
    shareIconsClasses() {
      return ['icons-list', { 'icons-list--vertical': this.isVerticalLayout }]
    }
  },
  methods: {
    getIconComponent({ icon }) {
      return icon === ICON.COMMENT_COUNT_ROUND_BLACK
        ? 'a-action-icon'
        : 'a-icon'
    },
    calculateIconStyle(index) {
      if (!this.autocalculatedMargins) return {}

      const style = {}
      const isLastIcon = index + 1 === this.icons.length
      if (isLastIcon) return style

      if (this.isVerticalLayout) {
        style['margin-bottom'] = `${this.verticalSpacing}px`
      } else {
        const iconsWidth = this.iconWidth * this.maxIconCount
        const spaceCount = this.maxIconCount - 1
        style['margin-right'] = `calc((100% - ${iconsWidth}px)/${spaceCount})`
      }
      return style
    },
    onIconClick({ isButton, mailto }) {
      if (!isButton) return

      this.$helper.mailto(mailto)
    }
  }
}
</script>

<style lang="scss" scoped>
.icons-list {
  display: flex;
  justify-content: center;
  width: 100%;

  &--vertical {
    flex-direction: column;
  }
}

.share-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-content: center;
  justify-content: center;
}
</style>
